import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import type React from 'react';
import { type Control, Controller, type FieldErrors } from 'react-hook-form';
import type { ClientDetailsFormData } from '../../schemas/clientDetailsSchema';

interface Props {
  control: Control<ClientDetailsFormData>;
  errors: FieldErrors<ClientDetailsFormData>;
  isStripeManaged: boolean;
}

export const OverviewTab: React.FC<Props> = ({ control, errors, isStripeManaged }) => {
  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="subscriptionStatus"
          control={control}
          render={({ field }) => (
            <FormControl fullWidth error={!!errors.subscriptionStatus}>
              <InputLabel id="status-label">Subscription Status</InputLabel>
              <Select
                {...field}
                labelId="status-label"
                label="Subscription Status"
                disabled={isStripeManaged}
              >
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="trialing">Trialing</MenuItem>
                <MenuItem value="past_due">Past Due</MenuItem>
                <MenuItem value="canceled">Canceled</MenuItem>
                <MenuItem value="pending_configuration">Pending Configuration</MenuItem>
              </Select>
            </FormControl>
          )}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="billingCurrency"
          control={control}
          render={({ field }) => (
            <FormControl fullWidth error={!!errors.billingCurrency}>
              <InputLabel id="billing-currency-label">Billing Currency</InputLabel>
              <Select {...field} labelId="billing-currency-label" label="Billing Currency">
                <MenuItem value="USD">USD ($)</MenuItem>
                <MenuItem value="AUD">AUD (A$)</MenuItem>
                <MenuItem value="GBP">GBP (£)</MenuItem>
              </Select>
            </FormControl>
          )}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="currentPeriodEnd"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              type="date"
              label="Current Period End"
              InputLabelProps={{ shrink: true }}
              disabled={isStripeManaged}
              helperText={errors.currentPeriodEnd?.message || 'Service expiry date'}
              error={!!errors.currentPeriodEnd}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};
